<template>
  <div class="animated fadeIn">
    <b-card>
      <irrigation-field-form-group
        :submission="submission_data"
        :index="index"
        @onFieldChange="onFieldChange"
      ></irrigation-field-form-group>
      <div
        v-if="submission_data.bore_holes && submission_data.bore_holes.length"
      >
        <irrigation-bore-hole-form-group
          v-for="(bore_hole, index) in submission_data.bore_holes"
          :key="index"
          :bore_hole="bore_hole"
          :textureOptions="textureOptions"
          :horizonOptions="horizonOptions"
          :boreHoleListLength="submission_data.bore_holes.length"
          @onBoreHoleChange="onBoreHoleChange"
          @onBoreHoleListChange="onBoreHoleListChange"
        ></irrigation-bore-hole-form-group>
      </div>
      <div v-if="turnArounds && turnArounds.models.length">
        <hr />
        <turn-around-select
          :turnArounds="turnArounds"
          :selectedTurnAround="submission_data.turnaround"
          @onTurnAroundSelect="onTurnAroundSelect"
        ></turn-around-select>
      </div>
      <div v-if="serviceQuestions && serviceQuestions.models.length">
        <hr />
        <service-question
          v-for="(serviceQuestion, index) in serviceQuestions.models"
          :key="index"
          :serviceQuestion="serviceQuestion"
        ></service-question>
      </div>
      <b-button
        class="mb-3"
        variant="success"
        block
        @click="onBoreHoleListChange({ action: 'add' })"
        ><i class="fa fa-plus"></i> Add Bore Hole</b-button
      >
      <b-button variant="danger" block @click="removeSubmission"
        ><i class="fal fa-trash"></i> Remove Submission</b-button
      >
    </b-card>
  </div>
</template>
<script>
import IrrigationBoreHoleFormGroup from "./IrrigationBoreHoleFormGroup";
import IrrigationFieldFormGroup from "./IrrigationFieldFormGroup";
import TurnAroundSelect from "../../TurnAroundSelect";
import TestPackageSampleCollection from "../../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import TurnaroundCollection from "../../../../collections/lab/TurnaroundCollection";
import ServiceQuestionCollection from "../../../../collections/lab/ServiceQuestionCollection";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "IrrigationForm",
  components: {
    IrrigationBoreHoleFormGroup,
    IrrigationFieldFormGroup,
    TurnAroundSelect
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submission: {
      type: Object,
      default: () => null
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    serviceQuestions: {
      type: Object,
      default: () => new ServiceQuestionCollection()
    },
    index: {
      type: Number,
      default: null
    },
    textureOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    horizonOptions: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      submission_data: null
    };
  },
  validations: {
    submission_data: {
      identifier: { required }
    }
  },
  methods: {
    onFieldChange(data) {
      if (data) {
        this.submission_data.identifier = data.identifier;
        this.submission_data.event_code = data.event_code;
        this.emitSubmissionChange();
      }
    },
    onBoreHoleListChange({ bore_hole_id, action }) {
      let boreHoleListUpdate;
      if (action === "remove") {
        boreHoleListUpdate = this.submission_data.bore_holes.filter(
          bore_hole => bore_hole.bore_hole_id !== bore_hole_id
        );
      } else {
        const new_bore_hole_id = this.$uuid.v4();
        const default_sample_list = Array(3).fill({
          identifier: null,
          test_package_sample_id: null,
          sample_irrigation_suitability: {
            number: null,
            bore_hole_id: new_bore_hole_id,
            depth_end: null,
            depth_start: null,
            field_texture: null,
            soil_horizon: null
          }
        });
        boreHoleListUpdate = [
          ...this.submission_data.bore_holes,
          {
            bore_hole_id: new_bore_hole_id,
            identifier: null,
            field_texture: null,
            soil_horizon: null,
            samples: default_sample_list.map((sample, index) => {
              let start = +index * 6;
              return {
                ...sample,
                identifier: `Sample ${+index + 1}`,
                test_package_sample_id: this.$uuid.v4(),
                sample_irrigation_suitability: {
                  ...sample.sample_irrigation_suitability,
                  number: index + 1,
                  depth_end: start + 6,
                  depth_start: start
                }
              };
            })
          }
        ];
      }
      this.submission_data.bore_holes = [...boreHoleListUpdate];
    },
    onBoreHoleChange({ bore_hole_id, data }) {
      this.submission_data.bore_holes = this.submission_data.bore_holes.map(
        bore_hole => {
          if (bore_hole.bore_hole_id === bore_hole_id) {
            return data;
          }
          return bore_hole;
        }
      );
      this.emitSubmissionChange();
    },
    onTurnAroundSelect(turnaround) {
      if (turnaround && turnaround.id) {
        this.submission_data.turnaround = turnaround;
        this.submission_data.turnaround_id = turnaround.id;
        this.emitSubmissionChange();
      } else {
        this.submission_data.turnaround = null;
        this.submission_data.turnaround_id = null;
        this.emitSubmissionChange();
      }
    },
    emitSubmissionChange() {
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      });
    },
    removeSubmission() {
      this.$emit("removeSubmission", this.index);
    }
  },
  watch: {
    submission: {
      handler(value) {
        this.submission_data = value;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.submission) {
      this.submission_data = this.submission;
    }
  }
};
</script>
